import React, {Component} from 'react';
import {Row, Col, Tag, message} from 'antd';
import Footer from "../exercise/Footer";
import Draggable from "react-draggable";
const colors = [
    '#db0a16','#d27324','#fff823','#28ee10',
    '#87CEEB', '#0000FF','#000000','#daded0',
    '#ffa9b8','#1E90FF', '#00E5EE','#9718ee',
    '#2e84cd','#cb11cd','#CD9B9B'
];
class Question extends Component {
    state = {
        visible: false
    };

    createHtml = str => ({__html: str ? str : `&nbsp;`});

    renderFillImg = (stem) => {
        const dragHandlers = {
            scale: 1,
            bounds: "parent",
            disabled: true,
            offsetParent: document.getElementById('offsetParent'),
            enableUserSelectHack: false,
        };
        let targets = stem.drag_list.map((i, index) => {
            return (
                <Draggable
                    key={index}
                    position={{x: i.position[0], y: i.position[1]}}
                    {...dragHandlers}
                >
                    <div className="empty-item"
                         style={{
                             width: stem.item_size[0],
                             height: stem.item_size[1],
                             lineHeight: stem.item_size[1] + 'px',
                             fontSize: '12px'
                         }}>目标{i.drag_id + 1}</div>
                </Draggable>
            )
        });
        let elements = stem.item_list.map((i, index) => {
            return (
                <Draggable
                    key={index}
                    position={{x: i.position[0], y: i.position[1]}}
                    {...dragHandlers}
                >
                    <div className="empty-item"
                         style={{
                             background: 'url(' + i.image_url + ')',
                             width: i.size[0] + 'px',
                             height: i.size[1] + 'px',
                             display: 'inline-block',
                             border:'2px solid '+ colors[index]
                         }}>
                    </div>
                </Draggable>
            )
        });
        return (
            <div id="offsetParent" style={{padding:'0' , textAlign:'left' , overflow:'scroll'}} className="img-blank-content">
                <div className="img-reverse">
                    <img src={stem.backgroup_url}/>
                </div>
                <div className="empty-list" style={{padding:'0'}}>
                    {targets}
                    {elements}
                </div>
            </div>
        )
    };

    render() {
        let {visible} = this.state;
        const {num} = this.props;
        let originData = this.props.data;
        let stem = JSON.parse(originData.stem);
        let answer = JSON.parse(originData.answer);
        let allow_repeat = stem.item_list[0].allow_repeat;//因为协议里面没有单独一个allow_repeat标志，item_list中的元素allow_repeat值相同，取一个即可
        return (
            <div className='box-exercise' ref={'viewer'}>
                <div className="exercise-content">
                    {num !== 'undefined' &&
                    <div className="exercise-num"><span className="math_text">{`${num + 1}、`}</span></div>}

                    <div className="exercise-con">
                        <Row>
                            <Col span={2}>
                                <span className="form-label">引导语：</span>
                            </Col>
                            <Col span={20}>
                                <div className="form-content">{stem.question}</div>
                            </Col>
                        </Row>
                        {/*引导音频*/}
                        {
                            stem.guide_audio &&
                            <Row>
                                <Col span={2}>
                                    <span className="form-label">引导音频：</span>
                                </Col>
                                <Col span={20}>
                                    <div className="form-content">
                                        <audio src={stem.guide_audio} controls="controls" width={300}/>
                                    </div>
                                </Col>
                            </Row>
                        }

                        {/*题干图片*/}
                        {this.renderFillImg(stem)}
                        {/*元素音频*/}

                        <Row>
                            <Col span={2}>
                                <span className="form-label">元素音频：</span>
                            </Col>
                            <Col span={20}>
                                <div className="form-content">
                                    {
                                        stem.item_list.map((i, index) =>
                                            i.audio_url ?
                                                <audio src={i.audio_url}
                                                       controls="controls"
                                                       width={300}
                                                       key={index}
                                                       style={{display: 'inline-block', marginRight: '10px'}}
                                                /> : null
                                        )
                                    }
                                </div>
                            </Col>
                        </Row>
                        {/*设置*/}
                        <Row>
                            <Col span={2}>
                                <span className="form-label">设置：</span>
                            </Col>
                            <Col span={10}>
                                <span style={{fontSize: '14px', lineHeight: '30px'}}>
                                    元素允许重复使用：{allow_repeat ? '是' : '否'}
                                </span>
                            </Col>
                            <Col span={10}>
                                 <span style={{fontSize: '14px', lineHeight: '30px'}}>
                                    元素自动整理：{stem.stop_order ? '是' : '否'}
                                </span>
                            </Col>
                        </Row>
                        {/*交互规则*/}
                        <Row>
                            <Col span={2}>
                                <span className="form-label">交互规则：</span>
                            </Col>
                            <Col span={20}>
                                {
                                    stem.adjust_rule.map((i, index) =>
                                        <div key={index} style={{fontSize: '14px', lineHeight: '30px'}}>
                                            {/*因为adjust_list的drag_id_list形式是数组，但只有一个值*/}
                                            <span style={{
                                                display: 'inlineBlock',
                                                margin: '0 20px'
                                            }}>目标{i.drag_id_list[0] + 1}:</span>
                                            {
                                                i.item_id_list.map((i, index) =>
                                                    <span
                                                        key={index}
                                                        style={{
                                                            display: 'inlineBlock',
                                                            margin: '0 20px'
                                                        }}>元素{i + 1}</span>
                                                )
                                            }
                                        </div>
                                    )
                                }
                            </Col>
                        </Row>
                    {/*    判题规则*/}
                    <Row style={{marginTop:'15px'}}>
                        <Col span={2}>
                            <span className="form-label">判题规则：</span>
                        </Col>
                        <Col span={20}>
                            {
                                answer.map((i,index) =>
                                <div key={index} style={{fontSize: '14px', lineHeight: '30px'}}>
                                    <span className="form-label" style={{display: 'inlineBlock', margin: '0 20px'}}>
                                        规则{index+1}：
                                    </span>
                                    {
                                        i.drag_id_list.map((dragItem,index) =>
                                            <span style={{display: 'inlineBlock', margin: '0 20px'}} key={index}>目标{Number(dragItem)+1}</span>
                                        )
                                    }

                                    <span className="form-label" style={{display: 'inlineBlock', margin: '0 20px'}}>
                                        答案:
                                    </span>
                                    {
                                        i.item_id_list.map((item,index) =>
                                            <span key={index} style={{display: 'inlineBlock', margin: '0 20px',color:colors[item]}}>元素{Number(item)+1}</span>
                                        )
                                    }

                                </div>
                                )
                            }
                        </Col>
                    </Row>
                    </div>
                </div>
                {/*    footer*/}
                <div className="exercise-footer">
                    {
                        visible &&
                        <div className="footer-hide relative">
                            <div>
                                <div className="inline-block"><span
                                    style={{fontSize: 14}}>{this.props.errorAnswer ? '错误答案：' : '正确答案：'}</span></div>
                                <div className="inline-block" style={{width: '80%'}}>
                                    <span style={{fontSize: 14}}
                                          dangerouslySetInnerHTML={this.createHtml(JSON.parse(originData.answer))}/>
                                </div>
                            </div>
                            {
                                data.explain && <div>
                                    <div className="inline-block"><span style={{fontSize: 14}}>答案解析：</span></div>
                                    <div className="inline-block">
                                        <span style={{fontSize: 14}}
                                              dangerouslySetInnerHTML={this.createHtml(data.explain)}/>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>

                            {/*~~~~~~~~~~~~~~~~~~~~~此题型暂时不显示答案~~~~~~~~~~~~*/}

                            {/*{*/}
                            {/*    this.props.canShowAnswer ?*/}
                            {/*        <button*/}
                            {/*            className="question-btn"*/}
                            {/*            onClick={(e) => this.toggleAnswer(!visible, e)}>*/}
                            {/*            {!visible ? '显示答案' : '隐藏答案'}*/}
                            {/*        </button> : null*/}

                            {/*}*/}
                        </Footer>
                    </div>
                </div>
            </div>
        )
    }
}

export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/fixDrag/viewForView.js